import React from "react";
import { Select } from "antd";

const { Option } = Select;

export const DistributionSelect = React.forwardRef(
    ({ distributionList = [], value, onChange }, ref) => (
        <Select
            ref={ref}
            value={value}
            onChange={onChange}
        >
            {distributionList.map(({ value, label }) => (
                <Option key={value} value={value}>
                    {label}
                </Option>
            ))}
        </Select>
    )
);